import React from 'react';
import { Controller } from 'react-hook-form';
import LabelName from 'components/UI/LabelName/LabelName';
import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';
import CaseListDropDown from 'components/CaseListDropDown/CaseListDropDown';

function EventCaseName({ control, errors, notLinkedToCaseWatcher }) {
  return (
    <div className="d-flex align-items-center py-2 flex-wrap">
      <div className="col-md-4 col-12">
        <LabelName required={!notLinkedToCaseWatcher} htmlFor="case">
          Case/Lead
        </LabelName>
      </div>
      <div className="col-md-8 col-12">
        <Controller
          name="case"
          control={control}
          rules={{
            required: !notLinkedToCaseWatcher ? 'Please select case/lead' : false,
            validate: (value) => {
              return !notLinkedToCaseWatcher ? (typeof value === 'object' ? true : 'Please select valid case/lead') : true;
            },
          }}
          render={({ field }) => (
            <CaseListDropDown
              value={field.value}
              onChange={(e) => field.onChange(e)}
              name="case"
              placeholder="Case/Lead Name"
              noOptionsMessage="No Cases/Leads Found"
              isClearable
              disabled={notLinkedToCaseWatcher}
              ref={field.ref}
            />
          )}
        />
      </div>
      <div className="offset-md-4">{errors?.case && <InputErrorMessage>{errors.case.message}</InputErrorMessage>}</div>
    </div>
  );
}

export default EventCaseName;
